export const films = [
  {
    id: "all-night-wrong",
    title: "All Night Wrong",
    genre: "Comedy",
    genres: ["Comedy", "Thriller"],
    year: "2026",
    tagline: "One night. Everything goes wrong.",
    isNew: true,
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/%7B4b9fe832-0bde-ed11-8297-0e4a64f8a357%7D/Screenshot%202026-09-01%20at%203.16.44%E2%80%AFPM_%7Beadfbfcf-52a6-f111-82ac-0e4a64f8a357%7D.png",
  },
  {
    id: "couples-weekend",
    title: "Couples Weekend",
    genre: "Comedy",
    genres: ["Comedy", "Romance"],
    year: "2026",
    tagline: "Four friends. One chaotic getaway.",
    isNew: true,
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/%7B658c4b66-1a92-ed11-8296-0e4a64f8a357%7D/Screenshot%202026-05-14%20at%2010.41.54%E2%80%AFAM_%7B56f55dff-1d85-f011-82a7-0e4a64f8a357%7D.png",
  },
  {
    id: "frontier-crucible",
    title: "Frontier Crucible",
    genre: "Western",
    genres: ["Western", "Action"],
    year: "2025",
    tagline: "You don't have to die to go to hell.",
    isNew: true,
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/Screenshot%202025-12-09%20at%205.20.42%E2%80%AFPM_%7B6f37d520-d484-ef11-82a2-0e4a64f8a357%7D.png",
  },
  {
    id: "safe-house",
    title: "Safe House",
    genre: "Action",
    genres: ["Action", "Thriller"],
    year: "2025",
    tagline: "Trust no one. Nowhere is safe.",
    isNew: true,
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/Screenshot%202025-10-13%20at%203.25.42%E2%80%AFPM_%7Bdf73ec3d-2a79-e511-9487-0e563b5fb261%7D.png",
  },
  {
    id: "stolen-girl",
    title: "Stolen Girl",
    genre: "Thriller",
    genres: ["Thriller", "Drama"],
    year: "2025",
    tagline: "A mother's desperate hunt for the truth.",
    isNew: true,
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/%7B32f62ae6-8b02-ef11-82a0-0e4a64f8a357%7D/Screenshot%202025-10-13%20at%203.10.13%E2%80%AFPM_%7Bd6df5d0a-8d02-ef11-82a0-0e4a64f8a357%7D.png",
  },
  {
    id: "under-fire",
    title: "Under Fire",
    genre: "Action",
    genres: ["Action", "Comedy"],
    year: "2025",
    tagline: "Two legends. One last score.",
    isNew: true,
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/Screenshot%202025-08-13%20at%205.04.39%E2%80%AFPM_%7B559ef706-43d5-ec11-828f-0e415c66ce57%7D.png",
  },
  {
    id: "marked-men",
    title: "Marked Men",
    genre: "Romance",
    genres: ["Romance", "Drama"],
    year: "2024",
    tagline: "Some rules are meant to break.",
    isNew: false,
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/Screenshot%202024-12-03%20at%203.51.49%E2%80%AFPM_%7B888fa75e-bfe8-eb11-8286-0e415c66ce57%7D.png",
  },
  {
    id: "aftermath",
    title: "Aftermath",
    genre: "Action",
    genres: ["Action", "Thriller"],
    year: "2024",
    tagline: "When the storm passes, the fight begins.",
    isNew: false,
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/Aftermath%20key%20art_%7B30ca527d-be6e-e411-bad0-d4ae527c3b65%7D.png",
  },
  {
    id: "beyond-after",
    title: "Beyond After",
    genre: "Drama",
    genres: ["Drama", "Romance"],
    year: "2025",
    tagline: "After the end, a new beginning.",
    isNew: false,
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/Screenshot%202025-02-24%20at%2012.08.09%E2%80%AFPM_%7B4c319a72-8798-ee11-829d-0e4a64f8a357%7D.png",
  },
  {
    id: "beautiful-wedding",
    title: "Beautiful Wedding",
    genre: "Romance",
    genres: ["Romance", "Comedy"],
    year: "2024",
    tagline: "Love is messy. So is the wedding.",
    isNew: false,
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/Screenshot%202023-12-11%20at%205.35.38%20PM_%7Bd9805bc3-fae1-ec11-828f-0e415c66ce57%7D.png",
  },
];

export const genres = [
  "All",
  "Action",
  "Thriller",
  "Romance",
  "Comedy",
  "Drama",
  "Western",
];